import { classNames } from '@ui-components-3/ui'
import { useMemo } from 'react'
import WeekDayBarSegment from './WeekDayBarSegment'
import { OperatingHoursBar } from 'hooks/operating-hours/types'

type WeekDayBarProps = {
  data: OperatingHoursBar
}

const WeekDayBar = ({ data }: WeekDayBarProps) => {
  const { title, segments, isHighlighted } = data || {}
  const labelPoints = useMemo(
    () =>
      [
        {
          label: '12am',
          leftPercentage: '0%',
        },
        {
          label: '6am',
          leftPercentage: '25%',
        },
        {
          label: 'noon',
          leftPercentage: '50%',
        },
        {
          label: '6pm',
          leftPercentage: '75%',
        },
        {
          label: '12am',
          leftPercentage: '100%',
        },
      ] as const,
    [],
  )

  if (!data) return null

  return (
    <li
      className={classNames(
        'border-b border-l-4 border-b-neutral-300',
        isHighlighted ? 'border-l-primary-600 bg-primary-100' : 'border-l-transparent',
      )}
    >
      <div className="px-4 py-2 sm:px-6 sm:py-3">
        <div className="typography-body mb-0.5 font-semibold text-neutral-800 sm:mb-1">{title}</div>
        <div className="relative mb-2 h-5">
          {labelPoints.map(({ leftPercentage, label }, i) => {
            const isFirstLabel = !i
            const isLastLabel = i >= labelPoints.length - 1

            return (
              <span
                key={String(i)}
                className={classNames(
                  'typography-small absolute top-0 flex w-10',
                  isFirstLabel
                    ? 'justify-start text-left'
                    : isLastLabel
                    ? '-translate-x-full justify-end text-right'
                    : '-translate-x-1/2 justify-center text-center',
                )}
                style={{
                  left: leftPercentage,
                }}
              >
                {label}
              </span>
            )
          })}
        </div>
        <div className="relative h-3 w-full overflow-hidden rounded-md bg-neutral-100 sm:h-4">
          {segments?.map((item, segmentIndex) => <WeekDayBarSegment key={String(segmentIndex)} segment={item} />)}
        </div>
      </div>
    </li>
  )
}

export default WeekDayBar
